export default __webpack_public_path__ + "static/media/border-10.d42bc95d.svg";